/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentOperation
 */
export interface PaymentOperation {
    /**
     * 
     * @type {Date}
     * @memberof PaymentOperation
     */
    created?: Date;
    /**
     * 
     * @type {string}
     * @memberof PaymentOperation
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentOperation
     */
    correlationId?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentOperation
     */
    eventCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentOperation
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PaymentOperation
     */
    merchantReference?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentOperation
     */
    reason?: string;
}

/**
 * Check if a given object implements the PaymentOperation interface.
 */
export function instanceOfPaymentOperation(value: object): boolean {
    return true;
}

export function PaymentOperationFromJSON(json: any): PaymentOperation {
    return PaymentOperationFromJSONTyped(json, false);
}

export function PaymentOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentOperation {
    if (json == null) {
        return json;
    }
    return {
        
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'type': json['type'] == null ? undefined : json['type'],
        'correlationId': json['correlationId'] == null ? undefined : json['correlationId'],
        'eventCode': json['eventCode'] == null ? undefined : json['eventCode'],
        'success': json['success'] == null ? undefined : json['success'],
        'merchantReference': json['merchantReference'] == null ? undefined : json['merchantReference'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function PaymentOperationToJSON(value?: PaymentOperation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'type': value['type'],
        'correlationId': value['correlationId'],
        'eventCode': value['eventCode'],
        'success': value['success'],
        'merchantReference': value['merchantReference'],
        'reason': value['reason'],
    };
}

